//***********************************REFRENCES******************************************* */
//---------------------------------- EmailTemplatesHeadersAndAccessors(EMT401)
//*************************************************************************************** */
//************************************EmailTemplatesHeadersAndAccessors(EMT401)********************************************* */
export const emailTemplatesList = {
  showPagination: false,
  showSerialNo: true,
  columns: [
    { Header: "Subject", accessor: "subject", sortable: false },
    {
      Header: "Type",
      accessor: "kind",
      sortable: false,
      width: 350,
    },
  ],
};

export const emailTemplateQuery = `query{
    allEmailtemplates{
        Emailtemplates
        {
          id
          message
          name
          kind
          subject
        }
      }  
  }`;
//********************************************************************************* */
export const saveEmailtemplate = `mutation saveEmailtemplate($obj:  EmailtemplateInput!){
  saveEmailtemplate(obj:$obj){
    id
  }
}`;

export const getEmailTemplate = `query($where:JSON){
  allEmailtemplates(where:$where){
      Emailtemplates
      {
        id
        message
        kind
        subject
      }
    }  
}`;
